import moment from 'moment';
import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import { formatDateShort } from '../../utility/dates';

class UserMetric extends LitEntity {
  static get properties() {
    return {
      stacked: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        align-items: center;
        display: flex;
        height: 100%;
      }

      bn-property[stacked] {
        min-width: 7em;
      }

      bn-property:not([stacked]) {
        --align-value: right;
        width: 100%;
      }

      .subdued {
        font-size: 0.9em;
      }
    `];
  }

  render() {
    if (!this.entity) {
      return html`
        <bn-icon name="fas fa-spinner fa-pulse"></bn-icon>
      `;
    }

    const { name, value, reportingDays, unit } = this.entity.properties;

    return html`
      <bn-property ?stacked=${this.stacked} label="${this._formatName(name, reportingDays)}">
        ${value !== undefined ? this._formatValue(value, unit) : html`
          <div class="subdued">Not recorded</div>`}
      </bn-property>
    `;
  }

  _formatName(name, reportingDays) {
    return `${name}${reportingDays ? ` (last ${reportingDays} days)` : ''}`;
  }

  _formatValue(value, unit) {
    if (value === 'external request failed') {
      return html`
        <bn-icon name="far fa-exclamation-circle" title="Error fetching data from PostHog"></bn-icon>
      `;
    }
    if (moment(value, moment.ISO_8601, true).isValid()) {
      return formatDateShort(value);
    }
    return html`${value}${unit ? html`<span class='unit'> minutes</span>` : ''}`;
  }
}

window.customElements.define('user-metric', UserMetric);
